import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';

export const TextEditorContainer = styled.div<{ $isSmall?: boolean }>`
  .ql-container {
    min-height: 4rem;
    min-height: ${({ $isSmall }) => ($isSmall ? '3rem' : '10rem')};
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;

    &.ql-disabled {
      border: none;
    }
  }

  .ql-editor {
    height: 100%;
    flex: 1;
    overflow-y: auto;
    width: 100%;
  }

  &:has(.ql-disabled) {
    border: 1px dashed ${COLORS.GRAY_LIGHT};
    color: ${COLORS.BLACK_PRIMARY};
    background: ${COLORS.WHITE};
    cursor: disabled;

    .ql-toolbar {
      border: none;
      border-bottom: 1px solid ${COLORS.SOFT_GRAY};
    }
  }
`;

export const StyledButtons = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledButton = styled(Button)`
  margin-left: 10px;
`;

export const StyledLabel = styled.div`
  display: flex;
  align-items: center;
  ${pickThemeFontStyles('12', '14', 'NORMAL')};
  margin-bottom: 0.5rem;

  &&& button {
    margin-left: 0.25rem;
  }
`;

export const StyledTextAreaWrap = styled.div`
  display: flex;
  flex-direction: column;
`;
